import { Component } from '@angular/core';
import { NavController, ViewController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';

@Component({
  selector: 'modal',
  templateUrl: 'modal.html'
})

export class ModalDoencas {
  doencas;
  doencasEscolhidas: Array<number> = [];
  doencasEscolhidasNomes = [];
  newData = [];
	doencasFiltradas: string = '';

  constructor(private navCtrl: NavController, private http: Http, public viewCtrl: ViewController) {}

  ionViewWillLoad(){
    this.getData();
  }

  addDoencaArray(id, nome){

		let index = this.doencasEscolhidas.indexOf(id);
		let doenca = {
			id: id,
			nome: nome
		};
		
		if(index > -1){

			this.doencasEscolhidas.splice(index, 1);
			this.doencasEscolhidasNomes.splice(index, 1);

			document.getElementById(nome).removeAttribute("style"); 

		} else {      
      this.doencasEscolhidas.push(id);

			this.doencasEscolhidasNomes.push(doenca);
			document.getElementById(nome).style.display = 'none';
		}
  }
  
  filtrar(){
		this.respGetData(this.doencasFiltradas).subscribe(data => {

			this.newData = [];

			for(var i = 0; i <= data.length-1; i++){

				var id = data[i].id;

				if(this.doencasEscolhidas.indexOf(id) === -1){
					this.newData.push(data[i]); 
				}
			}
			
			this.doencas = this.newData;
		});
	}

  getData(){
    this.respGetData('').subscribe(data => {
      this.doencas = data;
    });
  }

  respGetData(nome): Observable<any> {
    return this.http.get("http://maisalguemdoente.com.br/doencas/webService/getDoenca?nome="+nome).map((res: Response) => res.json());
  }

  fechaModal(){
    this.navCtrl.pop();
  }

  filtraMapa() {
    this.viewCtrl.dismiss(this.doencasEscolhidas);

    document.querySelector('.filter-icon').classList.add('active');
		document.querySelector('.filter-text').classList.add('active');
  }
}


// WEBPACK FOOTER //
// ./src/pages/vermapa/modal.ts